import React, { useState } from "react";
import FloatingLabelInput from "../../../../components/floatingLabelInput";
import FloatingLabelSelect from "../../../../components/floatingLabelSelect";
import { statesList } from "../../../../config/constant";
import ModalShell from "./modalShell";


const LocationDetailModal = ({ handleModalClose, organizationLevel, selectedOption, onSave, locationDetail }) => {
    const [data, setData] = useState(locationDetail);

    const handleSave = (e) => {
        e.preventDefault();

        if (selectedOption === "No location / virtual location") {
            data.city = '';
            data.state = '';
        } else {
            data.costCenterLocation = '';
        }

        onSave(data);

        // Close the modal
        handleModalClose();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update the specific field dynamically
        setData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    return (
        <ModalShell
            title={
                selectedOption !== "No location / virtual location"
                    ? `What city and state will the ${organizationLevel} be located in?`
                    : "What is the location of the cost center that you will be tied to?"
            }
            onClose={handleModalClose}
            maxWidth="max-w-2xl"
        >
                <form className="rize-modal-form profile-review-scrollbar flex-1 overflow-y-auto overscroll-contain px-5 pt-6 sm:px-8" onSubmit={handleSave}>
                    {
                        selectedOption === "No location / virtual location"
                            ? <div className="grid grid-cols-1 gap-x-4 gap-y-8">
                                <div className="sm:col-span-3">
                                    <FloatingLabelInput
                                        handleChange={handleChange}
                                        // handleBlur={handleBlur}
                                        value={data?.costCenterLocation || ''}
                                        // error={error.firstName}
                                        name="costCenterLocation"
                                        id="costCenterLocation"
                                        label="Cost center location"
                                        required={true}
                                    />
                                </div>
                            </div> :
                            <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                <div className="sm:col-span-3">
                                    <FloatingLabelInput
                                        handleChange={handleChange}
                                        // handleBlur={handleBlur}
                                        value={data?.city || ''}
                                        // error={error.firstName}
                                        name="city"
                                        id="city"
                                        label="City"
                                        required={true}
                                    />
                                </div>
                                <div className="sm:col-span-3">
                                    <FloatingLabelSelect
                                        handleChange={handleChange}
                                        value={data?.state || ''}
                                        name="state"
                                        id="state"
                                        label="State"
                                        options={statesList}
                                        required={true}
                                    />
                                </div>
                            </div>
                    }

                    <div className='sticky bottom-0 z-10 -mx-5 mt-8 flex flex-col justify-end gap-3 border-t border-slate-200 bg-white px-5 py-4 sm:-mx-8 sm:flex-row sm:px-8'>
                        <button
                            className="inline-flex h-11 w-full items-center justify-center rounded-xl border border-slate-300 bg-white px-5 text-sm font-semibold text-[#211b4f] hover:bg-slate-50 sm:w-auto"
                            type='button'
                            onClick={handleModalClose}
                        >
                            Cancel
                        </button>
                        <button
                            className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#211b4f] px-6 text-sm font-semibold text-white shadow-sm hover:bg-[#30266c] sm:w-auto"
                            type='submit'
                        >
                            Submit
                        </button>
                    </div>
                </form>
        </ModalShell>
    );
}

export default LocationDetailModal;
